import React from "react";
import "components/Feeds/Feeds.css";
import DefaultProfilePic from "site_media/images/default-profile-pic-feeds.png";
import { Player } from "video-react";
import Image from "react-bootstrap/Image";

/**
 * @description Displays the project completed by a friend of the user in the feed.
 * @class FriendCompletedProject
 * @implements none
 * @extends React.Component
 * @type {FriendCompletedProject}
 * @example <FriendCompletedProject />
 * pre-condition: all the imports
 * post-condition: returns a form with the message of project completed by a friend of the user.
 * @param profilePic, friendsName, video, projectName, time
 * @returns {FriendCompletedProject}
 */

class FriendCompletedProject extends React.Component {
  render() {
    let event = new Date(this.props.time);
    const formattedDate = Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }).format(event);
    const time = event.toLocaleTimeString("en-US");
    const url = this.props.video;

    return (
      <div className="feed-wrapper">
        <div className="feed-form">
          <p className="mobile-profile-pic">
            <img
              className="profile-pic"
              alt="profile-pic"
              src={this.props.profilePic || DefaultProfilePic}
            />
          </p>
          <p className="mobile-intro">
            <label style={{ fontWeight: "bold" }}>
              {this.props.friendsName}
            </label>
            <label>
              Project was completed on {formattedDate}, {time}
            </label>
          </p>
        </div>
        <div className="feed-display-video" style={{ width: this.props.width }}>          
          {url.match(/\.(jpeg|jpg|gif|png|JPG|JPEG|PNG)$/) != null ? (
              <Image src={url} className="w-100" />
            ) : (
              <Player
                className="video-player"
                fluid={false}
                playsInline
                src={url}
              />
            )}
        </div>
        <div className="feed-form">
          <label>
            Woo-hoo! {this.props.friendsName} just completed an impact
            project, <i>{this.props.projectName}</i>!
          </label>
        </div>
      </div>
    );
  }
}

export default FriendCompletedProject;
